import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import LooseFooter from './LooseFooter';

const BlogLayout = ({ 
  children, 
  id, 
  kind 
}) => {
  return (
    <>
      <div className="w-full shadow-none">
        <main className="text-gray-900 flex items-start mb-16" id="blog">
          {kind==="artigo" && 
            <article 
            id={id} 
              className="w-full w-full mt-12">
              {children}
            </article>
          }
          
          {kind==="index" && 
            <section 
            id={id} 
            className="w-full w-full mt-10 lg:mt-24">
              {children}
            </section>
          }
        </main>        
        <LooseFooter className="bg-gray-100" />
      </div>
    </>
  );    
}

export default BlogLayout

BlogLayout.PropTypes = {
  children: PropTypes.string.isRequired,
  id: PropTypes.string,
  kind: PropTypes.string.isRequired
}